module.exports = __webpack_public_path__ + "assets/css.212091e3.svg";